// Stylesheet order is load-bearing, and imports execute top to bottom, so the
// CSS must be imported BEFORE any component module (each pulls in its own
// stylesheet): the global reset first, then the design system, whose
// zero-specificity :where() primitives would otherwise lose their padding and
// margins to the equally zero-specificity `*` reset, then component CSS.
import './index.css';
import './styles/tokens.css';
import './styles/components.css';
// Mono font files (weights the UI uses), bundled instead of fetched from a
// font CDN. Titles/body use the system UI stack (see --ds-font-* tokens).
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import './i18n';
import { installApiClient } from './apiClient';
// import "./styles/ui.css";

installApiClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Root-level boundary: a render error anywhere outside the two
        feature-specific boundaries in Workflow.jsx previously blanked the
        whole app instead of showing a readable fallback. */}
    <ErrorBoundary>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
